import React from 'react'
import './H3.scss'

const H3 = ({text}) => {
  return (
    <h3>{text}</h3>
  )
}

export default H3